export enum LinkAssetType {
    General = "general",
    YouTube = "youtube",
    Vimeo = "vimeo",
    SoundCloud = "soundcloud"
}